import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './MobileFooter.module.scss'
import { NoCursorFightbackLogoImage } from '../icon/Icon'
import { MobileTitleLarge } from '../../Typography'
import { ROUTES } from '../../config/routes'
import { URLS } from '../../content/urls'

export const MobileFooter = (): ReactElement => {
  const navigate = useNavigate()

  return (
    <div>
      <footer className={styles.footer}>
        <div className={styles.logoBox}>{NoCursorFightbackLogoImage}</div>
        <div className={styles.linkBox}>
          <MobileTitleLarge
            darkFont={true}
            onClick={(): void => {
              navigate(ROUTES.impressum)
            }}
          >
            Impressum
          </MobileTitleLarge>
          <MobileTitleLarge
            darkFont={true}
            onClick={(): void => {
              navigate(ROUTES.datenschutz)
            }}
          >
            Datenschutz
          </MobileTitleLarge>
          <a href={URLS.oktv} target='_blank' rel='noreferrer'>
            OKTV Mainz
          </a>
          <a href={URLS.slWrestling} target='_blank' rel='noreferrer'>
            Merchandise
          </a>
          <a href={URLS.linktree} target='_blank' rel='noreferrer'>
            Linktree
          </a>
        </div>
      </footer>
    </div>
  )
}
